import {Font} from 'pepsico-ds'
export default Font
